import _ from "lodash";

import { default as React, Component, PropTypes } from "react";

import FaSpinner from "react-icons/lib/fa/spinner";

import withScriptjs from "react-google-maps/lib/async/withScriptjs";

import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";

import InfoBox from "react-google-maps/lib/addons/InfoBox";

/*
 * This is the modify version of:
 * https://developers.google.com/maps/documentation/javascript/examples/event-arguments
 *
 * Loaded using async loader.
 */
const AsyncGoogleMap = _.flowRight(withScriptjs, withGoogleMap)(props => (
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={props.zoom}
    defaultCenter={{ lat: props.lat, lng: props.lng }}
    defaultOptions={{
      //styles: GoogleMap.fancyMapStyles,
      mapTypeControl: false,
      streetViewControl: false,
      panControl: false,
      zoomControl: false,
      scrollwheel: false,
      draggable: false
    }}
    onClick={props.onMapClick}
  >
    <InfoBox
      defaultPosition={new google.maps.LatLng(props.lat, props.lng)}
      options={{
        closeBoxURL: ``,
        enableEventPropagation: true,
        disableAutoPan: false,
        maxWidth: 0,
        pixelOffset: { height: 0, width: -140 },
        alignBottom: true
      }}
      zIndex={999}
    >
      <div className="map-box">
        <div className="title">
          Biuro
        </div>
        <div className="description">
          Opiekujsie.pl / PQStudio
        </div>
        <div className="description">
          Żwirowa 54
        </div>
        <div className="description">
          66-400 Gorzów Wlkp.
        </div>
        <div className="description">
          Polska
        </div>
        <div className="link">
          <a
            href="https://www.google.pl/maps/place/%C5%BBwirowa+54,+Gorz%C3%B3w+Wielkopolski/@52.746531,15.2037915,14z/data=!4m5!3m4!1s0x47071f7a21a6c545:0x4fe9ca89e748269c!8m2!3d52.746531!4d15.221301"
            target="_blank"
          >
            OTWÓRZ W GOOGLE MAPS
          </a>
        </div>
      </div>
    </InfoBox>
  </GoogleMap>
));

export default class MyGoogleMap extends Component {
  state = {
    markers: [
      //{
      //position: {
      //lat: 25.0112183,
      //lng: 121.52067570000001,
      //},
      //key: `Taiwan`,
      //defaultAnimation: 2,
      //}
    ]
  };

  handleMapLoad = this.handleMapLoad.bind(this);
  handleMapClick = this.handleMapClick.bind(this);
  handleMarkerRightClick = this.handleMarkerRightClick.bind(this);

  handleMapLoad(map) {
    this._mapComponent = map;
  }

  /*
   * This is called when you click on the map.
   * Go and try click now.
   */
  handleMapClick(event) {
    //const nextMarkers = [
    //...this.state.markers,
    //{
    //position: event.latLng,
    //defaultAnimation: 2,
    //key: Date.now(), // Add a key property for: http://fb.me/react-warning-keys
    //},
    //];
    //this.setState({
    //markers: nextMarkers,
    //});
  }

  handleMarkerRightClick(targetMarker) {
    /*
     * All you modify is data, and the view is driven by data.
     * This is so called data-driven-development. (And yes, it's now in
     * web front end and even with google maps API.)
     */
    //const nextMarkers = this.state.markers.filter(marker => marker !== targetMarker);
    //this.setState({
    //markers: nextMarkers,
    //});
  }

  render() {
    const { apiKey, lat, lng, zoom } = this.props;

    return (
      <AsyncGoogleMap
        googleMapURL={
          "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=" +
            apiKey
        }
        lat={lat}
        lng={lng}
        zoom={zoom}
        loadingElement={
          (
            <div style={{ height: `100%`, width: "100%" }}>
              <FaSpinner
                style={{
                  display: `block`,
                  width: `80px`,
                  height: `80px`,
                  margin: `150px auto`,
                  animation: `fa-spin 2s infinite linear`
                }}
              />
            </div>
          )
        }
        containerElement={
          (
            <div
              style={{
                height: this.props.height,
                width: this.props.width,
                marginTop: this.props.marginTop
              }}
            />
          )
        }
        mapElement={<div style={{ height: `100%` }} />}
        onMapLoad={this.handleMapLoad}
        onMapClick={this.handleMapClick}
        markers={this.state.markers}
        onMarkerRightClick={this.handleMarkerRightClick}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/browser/components/GoogleMaps/GoogleMap.js
 **/